import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"

export default function FieldAge_TableCell(props:FieldTableCellProps) {

    return (
        <div className="cell-flex ui5-txt-less-important-small" style={getTableCellStyle(props)}>
            {props.field.getViewValue(props.listItem.task)}
        </div>
    )
}

